import { CommentFlashOutlineIcon } from './CommentFlashOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 68AA7A36-BF66-4F18-8BEE-78448FDBF5B9
 * name comment-flash-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/comment-flash-outline.svg
 * tags
 */
export const CommentQuickOutlineIcon = CommentFlashOutlineIcon;
export default CommentQuickOutlineIcon